import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var useFlexResize = function useFlexResize(hooks) {
  var spacerColumn = {
    id: 'spacer',
    width: 0,
    disableSortBy: true,
    disableResizing: true
  };
  hooks.visibleColumns.push(function (columns) {
    return [].concat(_toConsumableArray(columns), [spacerColumn]);
  });

  var changeProps = function changeProps(props, data) {
    var column = data.column;

    if (!column && data.cell) {
      column = data.cell.column;
    }

    if (column.id === spacerColumn.id) {
      return [props, {
        style: {
          flex: '1 1 0'
        }
      }];
    }

    return [props, {
      style: {
        flex: '0 0 auto'
      }
    }];
  };

  hooks.getHeaderProps.push(function (props, data) {
    return changeProps(props, data);
  });
  hooks.getCellProps.push(function (props, data) {
    return changeProps(props, data);
  });
};

export default useFlexResize;